module.exports = __webpack_public_path__ + "img/treeSapling.d81c7458.svg";